import type { FC } from 'react';
import { Form, Modal, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { TechnicianNameBadge } from '~/app/components/maintenance/work-orders/TechnicianNameBadge/TechnicianNameBadge';

export interface WorkOrderAssignDialogProps {
  open: boolean;
  workOrderCode: string;
  technicianOptions: Array<{ value: string; label: string }>;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (technicianId: string) => void;
}

type AssignFormValues = { technicianId: string };

export const WorkOrderAssignDialog: FC<WorkOrderAssignDialogProps> = ({
  open,
  workOrderCode,
  technicianOptions,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('maintenance');
  const [form] = Form.useForm<AssignFormValues>();

  return (
    <Modal
      open={open}
      title={t('workOrders.kanban.assign.title', { code: workOrderCode })}
      okText={t('workOrders.kanban.assign.confirm')}
      cancelText={t('workOrders.kanban.cancel')}
      confirmLoading={loading}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        void form.validateFields().then((values) => {
          onConfirm(values.technicianId);
          form.resetFields();
        });
      }}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="technicianId"
          label={t('workOrders.kanban.assign.technician')}
          rules={[
            {
              required: true,
              message: t('workOrders.kanban.assign.technicianRequired'),
            },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            options={technicianOptions}
            placeholder={t('workOrders.kanban.assign.technicianPlaceholder')}
            optionRender={(option) => (
              <TechnicianNameBadge name={String(option.label ?? '')} />
            )}
            labelRender={(props) => (
              <TechnicianNameBadge name={String(props.label ?? '')} />
            )}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
